import SyncProblemIcon from '@mui/icons-material/SyncProblem'
import { darken } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { MotionFab } from '@components'
import { useDatasetDataContext } from '@datasets/dataset-details/datasetData/context'
import { ActionType } from '@datasets/dataset-details/datasetData/context/types'
import { colors } from '@global/constants'

const useStyles = makeStyles(() => ({
  custom: {
    '&&': {
      backgroundColor: colors.blue.main,
      '&:hover': {
        backgroundColor: darken(colors.blue.main, 0.3),
      },
    },
  },
}))

/**
 * The overwrite file button in the read grid header
 */
export const OverwriteDataset = () => {
  const classes = useStyles()
  const { dispatch } = useDatasetDataContext()

  return (
    <MotionFab
      color="primary"
      tooltipTitle="Overwrite the data in this submission with corrected values"
      size="medium"
      className={classes.custom}
      onClick={handleClick}
      data-testid="overwrite-dataset"
    >
      <SyncProblemIcon data-testid="sync-problem-icon" />
    </MotionFab>
  )

  function handleClick(): void {
    dispatch({ type: ActionType.setModal, payload: { resubmitOpen: true } })
  }
}
